export default {
  FareOption__ACCRUAL_LABEL: "earn",
  FareOption__INVALID_WITH_DEPART_DATE_LABEL: "Invalid with depart date",
  FareOption__INVALID_WITH_RETURN_DATE_LABEL: "Invalid with return date",
  FareOption__SEATS_LEFT_LABEL: (data) => `${data.seatsLeft} left`,
  FareOption__SOLD_OUT_LABEL: "Sold out",
  FareOption__STARTING_AT_LABEL: "starting at",
  FareOption__UNAVAILABLE_LABEL: "Unavailable",
};
